// CreateStepper — wizard progress rail for the /add create flow.
// Substrate: design/add.html lines 167-204 — `<ol class="ap-stepper">`.
//
// Presentation-only (prop-driven, selector-free, dispatch-free). The
// step list is owned inline by CreateRealtyScreenContent and passed in;
// this is NOT a STEP_CONFIG / step-metadata registry — just the rail
// renderer. Per modernize.css, the wizard variant keys on
// `.add-property-page .ap-stepper` (NOT the edit `.ap-stepper--toc`).

import {
  STEP_STATE,
  STEP_STATE_LABELS,
} from "../lib/wizardContract";

const STATE_CLASS = {
  [STEP_STATE.ACTIVE]: "is-active",
  [STEP_STATE.COMPLETE]: "is-done",
  [STEP_STATE.INCOMPLETE]: "is-incomplete",
  [STEP_STATE.UPCOMING]: "is-upcoming",
};

function CreateStepper({ steps, current, stepStates, onJump }) {
  return (
    // Explicit role="list" is intentional (matches design/add.html):
    // .ap-stepper is `list-style: none`, which strips the implicit list
    // role in WebKit/VoiceOver — restoring it keeps the stepper a list to AT.
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ol
      className="ap-stepper"
      role="list"
      aria-label="Кроки створення оголошення"
    >
      {steps.map((step) => {
        const state = (stepStates && stepStates[step.n]) || (
          step.n === current
            ? STEP_STATE.ACTIVE
            : STEP_STATE.UPCOMING
        );
        const stateClass = STATE_CLASS[state] || STATE_CLASS[STEP_STATE.UPCOMING];
        const stateLabel = STEP_STATE_LABELS[state] || STEP_STATE_LABELS.upcoming;
        const liClass = `ap-step ${stateClass}`;
        return (
          <li
            key={step.n}
            className={liClass}
            data-target={step.n}
            data-step-state={state}
            aria-current={state === STEP_STATE.ACTIVE ? "step" : undefined}
          >
            <button
              type="button"
              className="ap-step__btn"
              onClick={() => onJump(step.n)}
              aria-label={`Крок ${step.n}: ${step.label} (${stateLabel})`}
            >
              <span className="ap-step__num" aria-hidden="true">{step.n}</span>
              <span className="ap-step__label">{step.label}</span>
              <span className="visually-hidden">{stateLabel}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}

export default CreateStepper;
